// LXRA Location Scout (Phase 4.0)

export const ADMIN_SCOUT = {
  tab: 'admin-tab-scout',
  section: 'admin-scout-section',
  form: 'admin-scout-form',
  locationInput: 'admin-scout-location-input',
  dateInput: 'admin-scout-date-input',
  timeInput: 'admin-scout-time-input',
  occasionInput: 'admin-scout-occasion-input',
  serviceSelect: 'admin-scout-service-select',
  subjectsInput: 'admin-scout-subjects-input',
  notesTextarea: 'admin-scout-notes-textarea',
  bookingSelect: 'admin-scout-booking-select',
  imageSwitch: 'admin-scout-image-switch',
  previewButton: 'admin-scout-preview-button',
  generateButton: 'admin-scout-generate-button',
  preview: 'admin-scout-preview',
  previewPlace: 'admin-scout-preview-place',
  previewSunrise: 'admin-scout-preview-sunrise',
  previewSunset: 'admin-scout-preview-sunset',
  previewSunAt: 'admin-scout-preview-sun-at',
  previewWeather: 'admin-scout-preview-weather',
  previewError: 'admin-scout-preview-error',
  gearHint: 'admin-scout-gear-hint',
  placesHint: 'admin-scout-places-hint',
  list: 'admin-scout-list',
  empty: 'admin-scout-empty',
  row: (id) => `admin-scout-row-${id}`,
  rowStatus: (id) => `admin-scout-row-status-${id}`,
  openButton: (id) => `admin-scout-open-${id}`,
  deleteButton: (id) => `admin-scout-delete-${id}`,
};

export const SCOUT_REPORT = {
  root: 'scout-report-page',
  backLink: 'scout-report-back-link',
  title: 'scout-report-title',
  status: 'scout-report-status',
  generating: 'scout-report-generating',
  error: 'scout-report-error',
  conceptImage: 'scout-report-concept-image',
  conceptPending: 'scout-report-concept-pending',
  conceptFailed: 'scout-report-concept-failed',
  regenerateImageButton: 'scout-report-regenerate-image-button',
  regenerateButton: 'scout-report-regenerate-button',
  referencePhotos: 'scout-report-reference-photos',
  referenceUnavailable: 'scout-report-reference-unavailable',
  referencePhoto: (i) => `scout-report-reference-photo-${i}`,
  mapsLink: 'scout-report-maps-link',
  sunTimeline: 'scout-report-sun-timeline',
  sunCompass: 'scout-report-sun-compass',
  weatherCard: 'scout-report-weather-card',
  section: (key) => `scout-report-section-${key}`,
  pinSelect: 'scout-report-pin-select',
  pinnedBadge: 'scout-report-pinned-badge',
  deleteButton: 'scout-report-delete-button',
  shootModeLink: 'scout-report-shoot-mode-link',
  blueprintLink: 'scout-report-blueprint-link',
};

export const GEAR_PROFILE = {
  card: 'admin-gear-card',
  bodiesTextarea: 'admin-gear-bodies-textarea',
  lensesTextarea: 'admin-gear-lenses-textarea',
  lightingTextarea: 'admin-gear-lighting-textarea',
  notesTextarea: 'admin-gear-notes-textarea',
  saveButton: 'admin-gear-save-button',
  summary: 'admin-gear-summary',
  linkedList: 'admin-gear-linked-list',
  linkedItem: (idx) => `admin-gear-linked-item-${idx}`,
};

export const SCOUT_ENTRY = {
  blueprintButton: 'admin-blueprint-scout-button',
  bookingButton: 'admin-booking-scout-button',
  bookingScoutLink: 'admin-booking-scout-link',
  shootModeCard: 'shoot-mode-scout-card',
  shootModeLink: 'shoot-mode-scout-link',
};

export const SIMULATOR = {
  section: 'scout-simulator-section',
  setup: 'scout-simulator-setup',
  frameSlider: 'scout-simulator-frame-slider',
  frameCount: 'scout-simulator-frame-count',
  timelapseSwitch: 'scout-simulator-timelapse-switch',
  estimate: 'scout-simulator-estimate',
  runButton: 'scout-simulator-run-button',
  clearButton: 'scout-simulator-clear-button',
  rerunButton: 'scout-simulator-rerun-button',
  progress: 'scout-simulator-progress',
  status: 'scout-simulator-status',
  error: 'scout-simulator-error',
  heroSpot: 'scout-simulator-hero-spot',
  timelapseStrip: 'scout-simulator-timelapse-strip',
  timelapseFrame: (i) => `scout-simulator-timelapse-${i}`,
  frame: (i) => `scout-simulator-frame-${i}`,
  frameImage: (i) => `scout-simulator-frame-image-${i}`,
  frameRerender: (i) => `scout-simulator-frame-rerender-${i}`,
  frameTab: (i, tab) => `scout-simulator-frame-${i}-tab-${tab}`,
  blocking: (i) => `scout-simulator-blocking-${i}`,
  // Phase 4.2
  liveSunSwitch: 'scout-simulator-live-sun-switch',
  liveSunStrip: 'scout-simulator-live-sun-strip',
  siteKey: 'scout-site-key',
  siteRefresh: 'scout-simulator-site-refresh',
  siteError: 'scout-simulator-site-error',
  editButton: (i) => `scout-simulator-frame-edit-${i}`,
  editTitle: (i) => `scout-simulator-frame-edit-title-${i}`,
  editTime: (i) => `scout-simulator-frame-edit-time-${i}`,
  editSpot: (i) => `scout-simulator-frame-edit-spot-${i}`,
  editMoment: (i) => `scout-simulator-frame-edit-moment-${i}`,
  editSave: (i) => `scout-simulator-frame-edit-save-${i}`,
  editCancel: (i) => `scout-simulator-frame-edit-cancel-${i}`,
  moveUp: (i) => `scout-simulator-frame-up-${i}`,
  moveDown: (i) => `scout-simulator-frame-down-${i}`,
  deleteFrame: (i) => `scout-simulator-frame-delete-${i}`,
  editedBadge: (i) => `scout-simulator-frame-edited-${i}`,
  addCard: 'scout-simulator-add-card',
  addTitle: 'scout-simulator-add-title',
  addTime: 'scout-simulator-add-time',
  addSubmit: 'scout-simulator-add-submit',
  dragHint: 'scout-simulator-drag-hint',
  // Phase 4.3 pins
  pinToolbar: 'scout-pin-toolbar',
  pinKind: (k) => `scout-pin-kind-${k}`,
  pinLabelInput: 'scout-pin-label-input',
  pinCancel: 'scout-pin-cancel',
  pinPlacingHint: 'scout-pin-placing-hint',
  pinChip: (id) => `scout-pin-chip-${id}`,
  pinRemove: (id) => `scout-pin-remove-${id}`,
  pinRename: (id) => `scout-pin-rename-${id}`,
};

export const SHOOT_POSITIONS = {
  section: 'shoot-positions-section',
  liveStrip: 'shoot-positions-live-strip',
  liveSwitch: 'shoot-positions-live-switch',
  card: (i) => `shoot-positions-card-${i}`,
  diagram: (i) => `shoot-positions-diagram-${i}`,
  nowBadge: (i) => `shoot-positions-now-${i}`,
  empty: 'shoot-positions-empty',
};

// Phase 4.5 — AI Pose Assistant
export const POSES = {
  tab: (i) => `scout-simulator-frame-${i}-tab-poses`,
  comfortNotes: 'scout-comfort-notes',
  comfortSaved: 'scout-comfort-notes-saved',
  empty: (i) => `scout-poses-empty-${i}`,
  generate: (i) => `scout-poses-generate-${i}`,
  loading: (i) => `scout-poses-loading-${i}`,
  error: (i) => `scout-poses-error-${i}`,
  list: (i) => `scout-poses-list-${i}`,
  card: (i, p) => `scout-pose-${i}-${p}`,
  name: (i, p) => `scout-pose-name-${i}-${p}`,
  cue: (i, p) => `scout-pose-cue-${i}-${p}`,
  figureSvg: (i, p) => `scout-pose-figure-${i}-${p}`,
  figure: (n) => `scout-pose-figure-person-${n}`,
  regenerate: (i) => `scout-poses-regenerate-${i}`,
  clear: (i) => `scout-poses-clear-${i}`,
};
